

export default {
  name: "TextSection",
  props: ['zone'],
}
